import { useContext, useState } from "react";
import { motion,  AnimatePresence } from "framer-motion";
import { dataContext } from "../../../context/context";
import './crm.css';
import logo3d from "../../../assets/images/logo.png";
import {useMediaQuery} from "react-responsive";



function Crm() {

    const {data, isLocal, setModal} = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);

    let urlPrefix = "/images/";
    if (isLocal) urlPrefix = "https://fnxstudio.ru" + urlPrefix;

    const section = data.sectionsdata.find(s => s.nick === 'crm');
    const paragraphs = section ? section.paragraphsdata : [];

    const isMobile = useMediaQuery({ query: "(max-width: 1000px)" });
    const [selected, setSelected] = useState(null);

    return (

        <motion.section
            id="crm"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.5, delay: 0.25 }}
            onAnimationComplete={() => {
                setShowItems(true);
            }}
        >
            <div className="inner_block">

                <h2><img src={logo3d} />{section.title}</h2>

                {
                    paragraphs.map((par) => (

                        <>

                            <h3>{par.title}</h3>
                            {par.text}

                            {
                                par.ul.length > 0 && (
                                    <ul>
                                        { par.ul.map((li, index) => (

                                            <li key={index}>{li}</li>

                                        ))
                                        }
                                    </ul>
                                )
                            }


                        </>

                    ))
                }

                <button onClick={() => setModal(true)}>Заказать разработку CRM</button>

            </div>
        </motion.section>



    )

}

export default Crm;